import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { IPlayNextVideoIconProps } from "interfaces";

const PlayNextVideoIcon = (props: IPlayNextVideoIconProps) => {
    return (
        <Image
            src={IMAGES.playNext}
            width={22}
            height={22}
            alt="playNext-icon"
            className="pl-cursor-pointer"
            {...props}
        />
    )
}

export default PlayNextVideoIcon;